(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('ReserveLimitCustom', ReserveLimitCustom);

    ReserveLimitCustom.$inject = ['$resource'];

    function ReserveLimitCustom($resource) {


        var getAllCompanyReserveLimits = function () {

            var resourceUrl = 'api/get-all-company-reserve-limits';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };


        return {
            getAllCompanyReserveLimits: getAllCompanyReserveLimits,

        };
    }
})();
